export const LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE = {
  ALL: getText('Everything'),
  JOB: getText('Jobs'),
  INTERNSHIP: getText('Internships'),
  VOLOP: getText('Volunteer Opportunities'),
  ORG: getText('Organizations'),
  GRAD_PROGRAM: getText('Graduate Programs'),
  EVENT: getText('Events'),
};
